import * as types from "./types";

const mutations = {
  [types.FLUID_LIST](state, payload) {
    // save in store
    state.fluidsList = payload;
  },
  [types.REFRIGERANT_LIST](state, payload) {
    // save in store
    state.refrigerantsList = payload;
  }
};

export default mutations;
